import { render, staticRenderFns } from "./FreeHex.vue?vue&type=template&id=240ae463&"
import script from "./FreeHex.vue?vue&type=script&lang=js&"
export * from "./FreeHex.vue?vue&type=script&lang=js&"
import style0 from "./FreeHex.vue?vue&type=style&index=0&id=240ae463&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports